import { jsx } from "react/jsx-runtime";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import { validateTidalLicense } from "../../base/index.js";
function Wysiwyg(props) {
  return /* @__PURE__ */ jsx(
    WysiwygIcon,
    {
      "data-testid": "Wysiwyg",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Wysiwyg",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Wysiwyg.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Wysiwyg"
};
validateTidalLicense();
export {
  Wysiwyg
};
//# sourceMappingURL=Wysiwyg.js.map
